module.exports = __webpack_public_path__ + "static/img/wav.a681c1e1.png";